import React, { FunctionComponent, ReactElement, useState } from 'react';
import styles from './VideoDetails.module.scss';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { ReactComponent as BookmarkIcon } from 'app/assets/images/bookmark.svg';
import { ReactComponent as PlayArrow } from 'app/assets/images//playArrow.svg';
import { _t } from 'app/utils/i18n';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import { getFromLocalStorage } from 'app/utils/localStorage';
import { useModal } from 'app/context/Modal';
import { handelUrlID } from 'app/utils/helpers';

interface Props {
  details: any;
  compId: string;
  additionalComponents?: ReactElement;
}

const isEn = !!(getFromLocalStorage('LNG') == 'en');
const VideoDetails: FunctionComponent<Props> = ({
  details,
  compId,
  additionalComponents,
}) => {
  const modal = useModal();
  const [isEnglishActiveTab, setIsEnglishActiveTab] = useState<boolean>(isEn);
  const [showMoreDetails, setShowMoreDetails] = useState(false);
  const newLineFormatter = (text: string) => {
    return text?.replace(/\\n/gi, '\n').replace(/\n/gi, '\n');
  };

  return (
    <>
      <div
        className={styles.VideoDetails}
        id={compId}
        data-testid="videoDetails-testid"
      >
        {details?.title_translated && (
          <div className={styles.Tabs}>
            <div
              className={`${styles.Tabs__ArTab} ${
                isEnglishActiveTab ? null : styles.active
              }`}
              data-testid={'switchToArabic-btn'}
              onClick={() => setIsEnglishActiveTab(false)}
            >
              AR
            </div>
            <div
              className={`${styles.Tabs__EnTab} ${
                isEnglishActiveTab ? styles.active : null
              }`}
              data-testid={'switchToEnglish-btn'}
              onClick={() => setIsEnglishActiveTab(true)}
            >
              EN
            </div>
          </div>
        )}
        <div
          className={styles.VideoDetails_Title}
          id={`${compId}-videoDetails-title`}
          data-testid="videoDetails-title"
        >
          <h3>
            {details?.title_translated.length > 0
              ? isEnglishActiveTab
                ? details.title
                : details?.title_translated
              : details.title}
          </h3>
          <BookmarkIcon />
        </div>
        <div
          className={styles.VideoDetails_Content}
          id={`${compId}-videoDetails-content`}
          data-testid="videoDetails-content"
        >
          <div
            className={styles.VideoImg}
            data-testid="viewImg-testid"
            onClick={() =>
              modal.show({
                videoUrl: `https://www.youtube.com/embed/${handelUrlID(
                  details?.url
                )}`,
              })
            }
          >
            <div>
              <img src={details.image} alt="alt" />
            </div>
            <div className={styles.VideoBtn}>
              <PlayArrow />
            </div>
          </div>
          <div className={styles.VideoPost}>
            <h5>{isEnglishActiveTab ? 'posts' : _t('trends:post')}</h5>
            <pre
              data-testid="post-videoDetails"
              className={`${styles.videoPost_Text} ${
                !showMoreDetails && styles.showLessDetails
              }`}
            >
              {details?.post_translated.length > 0
                ? isEnglishActiveTab
                  ? newLineFormatter(details?.post)
                  : newLineFormatter(details?.post_translated)
                : newLineFormatter(details?.post)}
            </pre>
            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon fontSize="small" />}
                aria-controls="panel1a-content"
                id="panel1a-header"
                style={{ padding: 0 }}
                data-testid="setShowMoreDetails"
                onClick={() => setShowMoreDetails(!showMoreDetails)}
              >
                <p className={styles.showMoreDetailsToggle}>
                  {showMoreDetails
                    ? _t('basic:see_less')
                    : _t('basic:see_more')}
                </p>
              </AccordionSummary>
            </Accordion>
          </div>
        </div>
        {/* {!!videoComments?.length && (
          <div className={classes.root}>
            <Accordion onChange={handleChange} data-testid="Accordion-testid">
              <AccordionSummary
                expandIcon={<ArrowIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography className={styles.heading}>
                  {expanded ? _t('basic:contract') : _t('basic:expand')}
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                {videoComments &&
                  videoComments.map((video: any, index: any) => (
                    <div key={index} className={styles.AccordionRow}>
                      <div className={styles.commentImg}>
                        <img src={video.thumbnail} alt="image" />
                      </div>
                      <div className={styles.Details}>
                        <h5>{video.name}</h5>
                        <p>{video.comment}</p>
                        <div className={styles.Actions}>
                          <span>
                            {_t('basic:like')}: {video.likes_count}
                          </span>
                          <span>
                            {_t('basic:reply')}: {video.reply_count}
                          </span>
                        </div>
                      </div>
                    </div>
                  ))}
              </AccordionDetails>
            </Accordion>
          </div>
        )} */}
      </div>
      <div className="position-relative">{additionalComponents}</div>
    </>
  );
};

export default VideoDetails;
